import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { useStore } from 'vuex'
import { onMounted, onUnmounted, ref, toRefs, watch } from 'vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
type Props = {
  position: {
    x: number
    y: number
  } | null
  hasArchiveButton: boolean
  hasDeleteButton: boolean
  hasDownloadButton?: boolean
  hasEditButton?: boolean
  numberOfButtons: number
}
type Emits = {
  (e: 'archive'): void
  (e: 'close'): void
  (e: 'download'): void
  (e: 'delete'): void
  (e: 'edit'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableMenuMini',
  props: {
    position: {},
    hasArchiveButton: { type: Boolean, default: false },
    hasDeleteButton: { type: Boolean, default: false },
    hasDownloadButton: { type: Boolean },
    hasEditButton: { type: Boolean },
    numberOfButtons: { default: 2 }
  },
  emits: ["archive", "close", "download", "delete", "edit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { position } = toRefs(props)
const emits = __emit
const store = useStore()

const clickCounter = ref(1)
const miniMenuRef = ref<HTMLElement | null>(null)

function close(event: MouseEvent | TouchEvent) {
  // Prevents the menu from closing when clicking on the menu button
  if (clickCounter.value > 0) {
    clickCounter.value--
    return
  }
  const target = event.target as HTMLElement
  if (!miniMenuRef.value?.contains(target)) {
    emits('close')
  }
}
function setNewMenuPosition() {
  const menu = miniMenuRef.value
  if (!menu || !position.value) return
  menu.style.left = store.state.mobileScreen
    ? position.value.x - 22 + 'px'
    : position.value.x - 118 + 'px'
  menu.style.top = store.state.mobileScreen
    ? position.value.y - 36 + 'px'
    : position.value.y + 4 + 'px'
}
watch(position, (newPos) => {
  if (newPos) setNewMenuPosition()
})
onMounted(() => {
  document.addEventListener('click', close)
  if (position.value) setNewMenuPosition()
})
onUnmounted(() => document.removeEventListener('click', close))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "miniMenuRef",
    ref: miniMenuRef,
    class: _normalizeClass(["mini-menu", {
      'mini-menu__one-button': _ctx.numberOfButtons === 1,
      'mini-menu__three-buttons': _ctx.numberOfButtons === 3
    }])
  }, [
    (_ctx.hasDownloadButton)
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 0,
          class: "mini-menu__button",
          iconLeft: require('@/design-system/assets/icons/Icon-Download.svg'),
          buttonText: _ctx.$t('general__text__download'),
          size: "small",
          onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('download')))
        }, null, 8, ["iconLeft", "buttonText"]))
      : _createCommentVNode("", true),
    (_ctx.hasEditButton)
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 1,
          class: "mini-menu__button",
          iconLeft: require('@/design-system/assets/icons/Icon-Edit-Medium.svg'),
          buttonText: _ctx.$t('general__text__edit'),
          size: "small",
          onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit')))
        }, null, 8, ["iconLeft", "buttonText"]))
      : _createCommentVNode("", true),
    (_ctx.hasArchiveButton)
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 2,
          class: "mini-menu__button",
          iconLeft: require('@/design-system/assets/icons/Icon-Archive.svg'),
          buttonText: _ctx.$t('general__text__archive'),
          size: "small",
          onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('archive')))
        }, null, 8, ["iconLeft", "buttonText"]))
      : _createCommentVNode("", true),
    (_ctx.hasDeleteButton)
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 3,
          class: "mini-menu__button",
          iconLeft: require('@/design-system/assets/icons/Icon-Trash-2.svg'),
          buttonText: _ctx.$t('general__text__delete'),
          size: "small",
          onOnClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete')))
        }, null, 8, ["iconLeft", "buttonText"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})